import React, { useState, useEffect, useRef } from 'react';
import { Table, Row, Col, Card, CardBody, Input, Button, CardHeader, FormGroup, ButtonGroup } from 'reactstrap'
import { useHistory } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import Select from 'react-select';
import { cedimi } from '../../../constant/globalConstantsTypeClients'
import { OverlayPanel } from 'primereact/overlaypanel';
import { Tag } from 'primereact/tag';
import './StyleSanitary.css';
import { SearchAsync } from '../../../components/elements/SearchAsync';
import DateRangePicker from 'react-bootstrap-daterangepicker'

export const IndexTypeMicro = (props) => {

    const {
        checkTypeClient, informationPatient, id_company, informationSampling, nim_Notification, listTest, handleCancelWorkOrderUpdate,
        number_format, totalW,
        isPayForCompany, subTotalW, totalTaxesW, valueTax, downloadQuoter,
        checkInvoice, deleteSamplingOrder, modalSample, toggleModalSample, handleDeleteSample, dataInfo, listReturnReason, handleChangeReturnReason,
        loadingIsDevolution, validPorcentejeSpecial,
        modalUpdateSample, toggleModalUpdateSample, handleEdit, formMic, handleChangeSample, saveUpdateSampling, loadingUpdate,
        listSample, handleSample, saveUpdateChangeSampling,
        listSite, handleEditSite, toggleModalUpdateSite, modalUpdateSite, handleChangeSite,
        saveUpdateSite, handleSite, saveUpdateChangeSite, _authorized_sanitary,

        // * CONFIGURATION OBSERVATION
        editObservation, toggleModalUpdateObservation, modalUpdateObservation, handleChangeObservation, saveUpdateObservation,

        // ? CONFIGURATION DETERMINATIONS
        handleListDet5erminations, toggleModalDeterminations, dataDetermination, modalAddDeterminations,

        searchExamProfileState, handleSelectExamChange, validRestrictCompany, _valid_url,
        newDeterminations, removeTestFromWorkOrder, sampleSelected,
        errors,
        saveDeterminations,
        loadingAddDeterminations,
        previewDetermination, togglePreviewD,

        //* delivery date
        minDate,
        study_delivery,
        handleApplySanitary,

        // * HISTÓRICO
        handleViewHistoric,
        dataHistorical,
        customSelectStyles

    } = props;


    const history = useHistory();
    var id_quoter = 0
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const op = useRef(null);

    const [selectedSiteQuotation, setSelectedSiteQuotation] = useState(null);
    const ops = useRef(null);

    const [selectedObservationQuotation, setSelectedObservation] = useState(null);
    const opss = useRef(null);



    useEffect(() => {
        if (isFirstLoad) {
            setIsFirstLoad(false);
        }
    }, [isFirstLoad]);

    // ? CONFIRMATIO QUOTER--

    const groupedData = informationSampling
        .map(sample => {

            return (sample.listSamples || [])
                .map(_sample => {

                    if (!_sample?.id_mic_detail_sample) return null;

                    const allTests = [
                        ...(listTest || []),
                        ...(newDeterminations || [])
                    ];

                    const relatedTests = allTests.filter(test =>
                        test.id_mic_detail_sample === _sample.id_mic_detail_sample
                    );

                    const formattedTests = relatedTests.map(test => ({
                        test_name: test?.name || test?.test_name || "------",
                        price: test?.price ?? 0,
                        contract_number: test?.contract_number ?? "N/A",
                        id_agreement: test?.id_agreement ?? 0,
                        price_Agremment: test?.price_Agremment ?? 0,
                        config_iva: test?.config_iva ?? false,
                        id_work_order_exam: test?.id_work_order_exam ?? null,
                        id_work_order_profile: test?.id_work_order_profile ?? null,
                        exist: test?.exist ?? true,
                        isNew: test?.isNew ?? false,
                        tempId: test?.tempId ?? null
                    }));

                    return {
                        id_mic_detail_sample: _sample.id_mic_detail_sample,
                        folio: _sample.folio ?? "-----",
                        name_mic_sample: _sample.name_mic_sample ?? "------",
                        name_mic_sampling: _sample.name_mic_sampling ?? "----",
                        name_mic_site: _sample.name_mic_site ?? "-------",
                        observations: _sample.observations ?? "------",

                        tests: formattedTests
                    };
                })
                .filter(item => item && item.tests.length > 0);
        })
        .flat();



    console.log("🚀 ~ IndexTypeMicro ~ groupedData:", groupedData)

    const getFormattedPrice = (_find, valueTax) => {
        let priceStr;

        if (_find?.config_iva) {
            if (_find?.id_agreement === null || _find?.id_agreement === 0) {
                priceStr = number_format(_find?.price, 2);
            } else {
                priceStr = number_format((_find?.price_Agremment).toFixed(2));
            }
        } else {
            if (_find?.id_agreement === null || _find?.id_agreement === 0) {
                priceStr = number_format((_find?.price * (valueTax === 16 ? 1.16 : 1.08)).toFixed(2));
            } else {
                priceStr = number_format((_find?.price_Agremment * (valueTax === 16 ? 1.16 : 1.08)).toFixed(2));
            }
        }
        return parseFloat(priceStr.replace(/[^0-9.]/g, ""));
    };


    return (
        <>
            {
                // * NEW CONFIGURATION
                <div className="pos-container">

                    {/* HEADER */}
                    <header className="pos-header">
                        <Row className="pos-header-row align-items-center w-100">
                            <Col xs="12" className="sanitary-header-container">
                                <div className="sanitary-header-actions">

                                    {checkTypeClient === 1 ? (
                                        <Button
                                            size="sm"
                                            className="pos-pill active"
                                            disabled
                                        >
                                            <i className="icofont icofont-user-alt-5 f-16"></i>
                                            &nbsp; Particular
                                        </Button>
                                    ) : (
                                        <Button
                                            size="sm"
                                            className="pos-pill active"
                                            disabled
                                        >
                                            <i className="icofont icofont-industries-alt-4 f-16"></i>
                                            &nbsp; Empresa
                                        </Button>
                                    )}

                                    <button
                                        className="wo-mini-btn back"
                                        onClick={() => history.goBack()}
                                        title="Regresar"
                                    >
                                        <i className="pi pi-arrow-left"></i>
                                    </button>

                                </div>

                                <div className="select-container">
                                    <Select
                                        classNamePrefix="select-pill"
                                        name="id_company"
                                        value={
                                            checkTypeClient === 1
                                                ? {
                                                    value: "patient",
                                                    label: `${informationPatient?.name ?? ""} ${informationPatient?.paternal_surname ?? ""} ${informationPatient?.maternal_surname ?? ""}`.trim()
                                                }
                                                : id_company ?? null
                                        }
                                        placeholder="Seleccione una empresa"
                                        styles={customSelectStyles}
                                        isDisabled={true}
                                    />
                                </div>

                                <div className="sampling-info-bar">

                                    <div className="sampling-info-item">
                                        <span>Observación:</span>
                                        <strong>
                                            {informationSampling[0]?.observation ?? "No se a anexedado ninguna observación"}
                                        </strong>
                                    </div>


                                    <div className="sampling-quoter">
                                        <Button
                                            title="Descargar cotización"
                                            size="sm"
                                            onClick={() => downloadQuoter(id_quoter, valueTax)}
                                            color="danger"
                                            className="sampling-pdf-btn"
                                        >
                                            <i className="fa fa-file-pdf-o"></i>
                                        </Button>
                                    </div>

                                    <div className="sampling-date">
                                        <span>Fecha de entrega:</span>

                                        <DateRangePicker
                                            initialSettings={{
                                                singleDatePicker: true,
                                                showDropdowns: true,
                                                minDate,
                                                timePicker: true,
                                                timePicker24Hour: true,
                                                autoUpdateInput: false,
                                                drops: "down",
                                                opens: "right",
                                                locale: {
                                                    format: "YYYY-MM-DD HH:mm",
                                                    applyLabel: study_delivery
                                                        ? "Actualizar fecha"
                                                        : "Agregar fecha",
                                                    cancelLabel: "Cancelar",
                                                    daysOfWeek: [
                                                        "Dom",
                                                        "Lun",
                                                        "Mar",
                                                        "Mié",
                                                        "Jue",
                                                        "Vie",
                                                        "Sáb"
                                                    ],
                                                    monthNames: [
                                                        "Enero",
                                                        "Febrero",
                                                        "Marzo",
                                                        "Abril",
                                                        "Mayo",
                                                        "Junio",
                                                        "Julio",
                                                        "Agosto",
                                                        "Septiembre",
                                                        "Octubre",
                                                        "Noviembre",
                                                        "Diciembre"
                                                    ]
                                                }
                                            }}
                                            onApply={handleApplySanitary}
                                        >
                                            <input
                                                type="text"
                                                readOnly
                                                className="delivery-date-input"
                                                value={study_delivery || ""}
                                                placeholder="Sin fecha y hora asignada"
                                            />
                                        </DateRangePicker>
                                    </div>

                                    {dataHistorical?.length > 0 && (
                                        <div
                                            className="sampling-history"
                                            onClick={handleViewHistoric}
                                            title="Ver historial de resultados"
                                        >
                                            <i className="pi pi-history"></i>

                                            <span className="sampling-history-text">Historial</span>

                                            <span className="sampling-history-count">
                                                {dataHistorical.length}
                                            </span>
                                        </div>
                                    )}

                                </div>

                            </Col>
                        </Row>

                    </header>





                    {/* BODY */}
                    <div className="pos-body">

                        {/* MAIN */}
                        <div className="pos-main">
                            <div className="pos-main-fixed">
                                <div className="pd-container">
                                    <div className="pd-header-blue pb-2">
                                        <Row>
                                            <Col sm="9">
                                                <div className="patient-card horizontal" >
                                                    <div className="avatar">
                                                        <img
                                                            className="rounded-circle"
                                                            src={
                                                                informationPatient.gender?.toUpperCase() === "MASCULINO"
                                                                    ? require("../../../assets/images/user/hombre.png")
                                                                    : informationPatient.gender?.toUpperCase() === "FEMENINO"
                                                                        ? require("../../../assets/images/user/mujer.png")
                                                                        : require("../../../assets/images/laboratory-External/overdueNA.svg")
                                                            }
                                                            style={{ width: "37px", height: "35px" }}
                                                            alt="Avatar"
                                                        />

                                                        <span className="status-dot"></span>
                                                    </div>
                                                    <div className="patient-info">
                                                        <div className="patient-inline">
                                                            <span>
                                                                <span>NIM:</span>
                                                                <strong>{nim_Notification ?? "-----"}</strong>
                                                            </span>

                                                            <span>
                                                                <span>Cotización:</span>
                                                                <strong>
                                                                    {informationSampling[0]?.name_quoter ?? "-----"}
                                                                </strong>
                                                            </span>


                                                            <span>
                                                                <span>Plan:</span>
                                                                <strong>
                                                                    {informationSampling[0]?.sampling_plan ?? "-----"}
                                                                </strong>
                                                            </span>


                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                    </div>

                                </div>

                            </div>

                            {
                                // * PATIENT AND DOCTOR COMPONENT
                            }

                            <div className="pos-main-scroll">


                                <Col sm="12 " className='container-global-zoom pl-0 pr-0'  >

                                    <Card className='pl-3 pr-3 pt-3 pb-3' >

                                        <Table className="b-r-5 table table-sm align-middle">
                                            <thead
                                                className="b-r-5"
                                                style={{
                                                    textAlign: "center",
                                                    backgroundColor: "#002940"
                                                }}
                                            >
                                                <tr>

                                                    <th style={{ color: "#fff" }}>
                                                        <b>Folio</b>
                                                    </th>

                                                    <th
                                                        className={
                                                            validPorcentejeSpecial === cedimi
                                                                ? "d-none"
                                                                : ""
                                                        }
                                                        style={{
                                                            color: "#fff",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        <i
                                                            className="fa fa-trash-o"
                                                            style={{
                                                                color: "#fff",
                                                                fontSize: "14px"
                                                            }}
                                                        ></i>
                                                    </th>

                                                    <th style={{ color: "#fff" }}>
                                                        <b>Tipo de Muestra</b>
                                                    </th>

                                                    <th style={{ color: "#fff" }}>
                                                        <b>Descripción de la muestra</b>
                                                    </th>

                                                    <th style={{ color: "#fff" }}>
                                                        <b>Determinaciones</b>
                                                    </th>

                                                    <th style={{ color: "#fff" }}>
                                                        <b>Lugar de toma</b>
                                                    </th>

                                                    <th style={{ color: "#fff" }}>
                                                        <b>Observaciones</b>
                                                    </th>

                                                    <th style={{ color: "#fff" }}>
                                                        <b>Precio</b>
                                                    </th>

                                                    <th
                                                        style={{ color: "#fff" }}
                                                        className={
                                                            checkTypeClient === 1
                                                                ? "d-none"
                                                                : ""
                                                        }
                                                    >
                                                        <b>Convenio</b>
                                                    </th>

                                                    <th
                                                        className={
                                                            validPorcentejeSpecial === cedimi
                                                                ? "d-none"
                                                                : ""
                                                        }
                                                        style={{
                                                            color: "#fff",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        <i
                                                            className="fa fa-trash-o"
                                                            style={{
                                                                color: "#fff",
                                                                fontSize: "14px"
                                                            }}
                                                        ></i>
                                                    </th>

                                                </tr>
                                            </thead>

                                            <tbody>

                                                {groupedData.map((item, index) => {

                                                    const pricesFormatted = item.tests.map((_find) => {

                                                        let priceStr;

                                                        if (_find?.config_iva) {

                                                            if (
                                                                _find?.id_agreement === null ||
                                                                _find?.id_agreement === 0
                                                            ) {
                                                                priceStr = number_format(
                                                                    _find?.price,
                                                                    2
                                                                );
                                                            } else {
                                                                priceStr = number_format(
                                                                    _find?.price_Agremment,
                                                                    2
                                                                );
                                                            }

                                                        } else {

                                                            if (
                                                                _find?.id_agreement === null ||
                                                                _find?.id_agreement === 0
                                                            ) {
                                                                priceStr = number_format(
                                                                    _find?.price *
                                                                    (valueTax === 16 ? 1.16 : 1.08),
                                                                    2
                                                                );
                                                            } else {
                                                                priceStr = number_format(
                                                                    _find?.price_Agremment *
                                                                    (valueTax === 16 ? 1.16 : 1.08),
                                                                    2
                                                                );
                                                            }
                                                        }

                                                        return parseFloat(
                                                            priceStr.replace(/[^0-9.]/g, "")
                                                        );
                                                    });


                                                    const idWo = item.tests.flatMap((_find) => {

                                                        const ids = [];

                                                        const examId =
                                                            _find?.id_work_order_exam;

                                                        const profileId =
                                                            _find?.id_work_order_profile;

                                                        if (
                                                            examId !== null &&
                                                            examId !== undefined
                                                        ) {
                                                            ids.push(examId);
                                                        }

                                                        if (
                                                            profileId !== null &&
                                                            profileId !== undefined
                                                        ) {
                                                            ids.push(profileId);
                                                        }

                                                        return ids;
                                                    });


                                                    const testRowStyle = {
                                                        minHeight: "30px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginBottom: "4px"
                                                    };


                                                    return (

                                                        <tr
                                                            key={index}
                                                            style={{
                                                                textAlign: "center",
                                                                border: "1px solid #ddd",
                                                                verticalAlign: "middle"
                                                            }}
                                                        >

                                                            {/* FOLIO */}
                                                            <td
                                                                className="txt-secondary f-w-600"
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px"
                                                                }}
                                                            >
                                                                <Tag
                                                                    value={item.folio}
                                                                    severity="info"
                                                                    style={{
                                                                        fontSize: "11px",
                                                                        fontWeight: "bold"
                                                                    }}
                                                                />
                                                            </td>


                                                            {/* ACCIONES DE MUESTRA */}
                                                            <td
                                                                className={
                                                                    validPorcentejeSpecial === cedimi
                                                                        ? "d-none"
                                                                        : ""
                                                                }
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "6px",
                                                                    width: "60px"
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        gap: "6px"
                                                                    }}
                                                                >

                                                                    <Button
                                                                        size="sm"
                                                                        color="danger"
                                                                        onClick={() =>
                                                                            handleDeleteSample(
                                                                                true,
                                                                                item?.id_mic_detail_sample,
                                                                                item.name_mic_sample,
                                                                                pricesFormatted,
                                                                                idWo,
                                                                                item.folio,
                                                                                groupedData.length === 1
                                                                            )
                                                                        }
                                                                        style={{
                                                                            width: "26px",
                                                                            height: "26px",
                                                                            borderRadius: "50%",
                                                                            padding: "0"
                                                                        }}
                                                                        title={`Eliminar muestra de: ${item?.name_mic_sample}`}
                                                                    >
                                                                        <i
                                                                            className="fa fa-trash-o"
                                                                            style={{
                                                                                fontSize: "12px"
                                                                            }}
                                                                        ></i>
                                                                    </Button>


                                                                    {validPorcentejeSpecial !== cedimi &&
                                                                        _authorized_sanitary === "True" && (

                                                                            <Button
                                                                                size="sm"
                                                                                color="primary"
                                                                                onClick={() =>
                                                                                    handleListDet5erminations(
                                                                                        item.folio,
                                                                                        item?.id_mic_detail_sample,
                                                                                        item.name_mic_sample,
                                                                                        pricesFormatted,
                                                                                        idWo,
                                                                                        groupedData.length === 1
                                                                                    )
                                                                                }
                                                                                style={{
                                                                                    width: "26px",
                                                                                    height: "26px",
                                                                                    borderRadius: "50%",
                                                                                    padding: "0"
                                                                                }}
                                                                                title={`Agregar determinación al folio: ${item?.folio}`}
                                                                            >
                                                                                <i
                                                                                    className="fa fa-plus"
                                                                                    style={{
                                                                                        fontSize: "12px"
                                                                                    }}
                                                                                ></i>
                                                                            </Button>

                                                                        )}

                                                                </div>
                                                            </td>


                                                            {/* TIPO DE MUESTRA */}
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px"
                                                                }}
                                                            >
                                                                {item.name_mic_sample}
                                                            </td>


                                                            {/* DESCRIPCIÓN DE LA MUESTRA */}
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px"
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        cursor:
                                                                            _authorized_sanitary === "True"
                                                                                ? "pointer"
                                                                                : "default"
                                                                    }}
                                                                    onClick={(e) => {

                                                                        if (
                                                                            _authorized_sanitary ===
                                                                            "True"
                                                                        ) {

                                                                            if (ops.current) {
                                                                                ops.current.hide();
                                                                            }

                                                                            if (opss.current) {
                                                                                opss.current.hide();
                                                                            }

                                                                            setSelectedQuotation(item);

                                                                            setTimeout(() => {

                                                                                if (op.current) {
                                                                                    op.current.toggle(e);
                                                                                }

                                                                            }, 0);
                                                                        }
                                                                    }}
                                                                >
                                                                    {item.name_mic_sampling}
                                                                </span>
                                                            </td>


                                                            {/* DETERMINACIONES */}
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "6px",
                                                                    width: "420px"
                                                                }}
                                                            >

                                                                {item.tests.map((_find, i) => (

                                                                    <div
                                                                        key={i}
                                                                        style={{
                                                                            ...testRowStyle,
                                                                            justifyContent:
                                                                                "space-between",
                                                                            padding: "0 8px",
                                                                            borderRadius: "6px",
                                                                            background:
                                                                                _find?.isNew
                                                                                    ? "#fff3cd"
                                                                                    : "#f4f6f7"
                                                                        }}
                                                                    >

                                                                        <span
                                                                            style={{
                                                                                textAlign: "left",
                                                                                flex: 1
                                                                            }}
                                                                        >
                                                                            {_find?.test_name}
                                                                        </span>


                                                                        {_find?.isNew && (

                                                                            <div
                                                                                style={{
                                                                                    display: "flex",
                                                                                    alignItems: "center"
                                                                                }}
                                                                            >

                                                                                <span
                                                                                    style={{
                                                                                        fontSize: "11px",
                                                                                        fontWeight: "700",
                                                                                        color: "#d70909",
                                                                                        marginRight: "7px"
                                                                                    }}
                                                                                >
                                                                                    NUEVO
                                                                                </span>

                                                                                <button
                                                                                    onClick={() =>
                                                                                        removeTestFromWorkOrder(
                                                                                            _find,
                                                                                            item
                                                                                        )
                                                                                    }
                                                                                    style={{
                                                                                        border: "none",
                                                                                        background: "transparent",
                                                                                        color: "#b30808",
                                                                                        cursor: "pointer",
                                                                                        padding: "0"
                                                                                    }}
                                                                                    title={`Eliminar ${_find?.test_name}`}
                                                                                >
                                                                                    ✕
                                                                                </button>

                                                                            </div>

                                                                        )}

                                                                    </div>

                                                                ))}

                                                            </td>


                                                            {/* LUGAR DE TOMA */}
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px"
                                                                }}
                                                            >

                                                                <span
                                                                    style={{
                                                                        cursor:
                                                                            _authorized_sanitary === "True"
                                                                                ? "pointer"
                                                                                : "default"
                                                                    }}
                                                                    onClick={(e) => {

                                                                        if (
                                                                            _authorized_sanitary ===
                                                                            "True"
                                                                        ) {

                                                                            if (op.current) {
                                                                                op.current.hide();
                                                                            }

                                                                            if (opss.current) {
                                                                                opss.current.hide();
                                                                            }

                                                                            setSelectedSiteQuotation(item);

                                                                            setTimeout(() => {

                                                                                if (ops.current) {
                                                                                    ops.current.toggle(e);
                                                                                }

                                                                            }, 0);
                                                                        }
                                                                    }}
                                                                >
                                                                    {item.name_mic_site}
                                                                </span>

                                                            </td>


                                                            {/* OBSERVACIONES */}
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "8px"
                                                                }}
                                                            >

                                                                <span
                                                                    style={{
                                                                        cursor:
                                                                            _authorized_sanitary === "True"
                                                                                ? "pointer"
                                                                                : "default",
                                                                        whiteSpace: "normal",
                                                                        wordBreak: "break-word",
                                                                        lineHeight: "1.4"
                                                                    }}
                                                                    onClick={(e) => {

                                                                        if (
                                                                            _authorized_sanitary ===
                                                                            "True"
                                                                        ) {

                                                                            if (op.current) {
                                                                                op.current.hide();
                                                                            }

                                                                            if (ops.current) {
                                                                                ops.current.hide();
                                                                            }

                                                                            setSelectedObservation(item);

                                                                            setTimeout(() => {

                                                                                if (opss.current) {
                                                                                    opss.current.toggle(e);
                                                                                }

                                                                            }, 0);
                                                                        }
                                                                    }}
                                                                >
                                                                    {item.observations ||
                                                                        "Sin observaciones"}
                                                                </span>

                                                            </td>


                                                            {/* PRECIO */}
                                                            <td
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "6px",
                                                                    minWidth: "85px"
                                                                }}
                                                            >
                                                                {item.tests.map((_find, i) => {

                                                                    const price =
                                                                        _find?.config_iva
                                                                            ? (
                                                                                _find?.id_agreement === null ||
                                                                                    _find?.id_agreement === 0
                                                                                    ? _find?.price
                                                                                    : _find?.price_Agremment
                                                                            )
                                                                            : (
                                                                                _find?.id_agreement === null ||
                                                                                    _find?.id_agreement === 0
                                                                                    ? _find?.price *
                                                                                    (valueTax === 16 ? 1.16 : 1.08)
                                                                                    : _find?.price_Agremment *
                                                                                    (valueTax === 16 ? 1.16 : 1.08)
                                                                            );

                                                                    return (
                                                                        <div
                                                                            key={i}
                                                                            style={{
                                                                                ...testRowStyle,
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center"
                                                                            }}
                                                                        >
                                                                            <span
                                                                                style={{
                                                                                    background: "#ff7a00",
                                                                                    color: "#fff",
                                                                                    fontWeight: "700",
                                                                                    fontSize: "11px",
                                                                                    padding: "4px 10px",
                                                                                    borderRadius: "20px",
                                                                                    minWidth: "42px",
                                                                                    textAlign: "center",
                                                                                    display: "inline-block",
                                                                                    lineHeight: "1.2",
                                                                                    boxShadow: "0 1px 3px rgba(0,0,0,0.12)"
                                                                                }}
                                                                            >
                                                                                $ {number_format(price, 2)}
                                                                            </span>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </td>


                                                            {/* CONVENIO */}
                                                            <td
                                                                className={
                                                                    checkTypeClient === 1
                                                                        ? "d-none"
                                                                        : ""
                                                                }
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "6px"
                                                                }}
                                                            >

                                                                {item.tests.map((_find, i) => (

                                                                    <div
                                                                        key={i}
                                                                        style={testRowStyle}
                                                                    >
                                                                        {_find?.contract_number ??
                                                                            "N/A"}
                                                                    </div>

                                                                ))}

                                                            </td>


                                                            {/* ELIMINAR DETERMINACIÓN */}
                                                            <td
                                                                className={
                                                                    validPorcentejeSpecial === cedimi
                                                                        ? "d-none"
                                                                        : ""
                                                                }
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "6px",
                                                                    width: "45px"
                                                                }}
                                                            >

                                                                {item.tests.map((_find, i) => {

                                                                    const priceFormatted =
                                                                        getFormattedPrice(
                                                                            _find,
                                                                            valueTax
                                                                        );

                                                                    return (

                                                                        <div
                                                                            key={i}
                                                                            style={testRowStyle}
                                                                        >

                                                                            {!_find?.isNew && (

                                                                                <Button
                                                                                    size="sm"
                                                                                    color="danger"
                                                                                    onClick={() =>
                                                                                        handleDeleteSample(
                                                                                            false,
                                                                                            item?.id_mic_detail_sample,
                                                                                            _find?.test_name,
                                                                                            priceFormatted,
                                                                                            _find?.id_work_order_exam,
                                                                                            item.folio,
                                                                                            false,
                                                                                            _find?.id_work_order_profile,
                                                                                            groupedData
                                                                                        )
                                                                                    }
                                                                                    style={{
                                                                                        width: "25px",
                                                                                        height: "25px",
                                                                                        borderRadius:
                                                                                            "50%",
                                                                                        padding: "0"
                                                                                    }}
                                                                                    title={`Eliminar determinación de: ${_find?.test_name}`}
                                                                                >
                                                                                    <i
                                                                                        className="fa fa-trash-o"
                                                                                        style={{
                                                                                            fontSize:
                                                                                                "12px"
                                                                                        }}
                                                                                    ></i>
                                                                                </Button>

                                                                            )}

                                                                        </div>

                                                                    );
                                                                })}

                                                            </td>

                                                        </tr>
                                                    );

                                                })}

                                            </tbody>
                                        </Table>

                                        <OverlayPanel
                                            ref={op}
                                            className="ios-sample-popover"
                                            appendTo={document.body}
                                        >
                                            <div className="ios-sample-popover-content">

                                                <div className="ios-sample-popover-top">

                                                    <span>
                                                        Descripción de la muestra
                                                    </span>

                                                    <strong>
                                                        {selectedQuotation?.name_mic_sampling}
                                                    </strong>

                                                </div>


                                                <div className="ios-sample-popover-actions">

                                                    <button
                                                        type="button"
                                                        onClick={() => {

                                                            if (op.current) {
                                                                op.current.hide();
                                                            }

                                                            handleEdit(
                                                                selectedQuotation.id_mic_detail_sample,
                                                                selectedQuotation.id_mic_sample,
                                                                selectedQuotation.name_mic_sampling,
                                                                selectedQuotation.name_mic_sample,
                                                                selectedQuotation.id_mic_site,
                                                                false
                                                            );
                                                        }}
                                                    >
                                                        <i className="pi pi-pencil"></i>
                                                        Renombrar
                                                    </button>


                                                    <button
                                                        type="button"
                                                        onClick={() => {

                                                            if (op.current) {
                                                                op.current.hide();
                                                            }

                                                            handleEdit(
                                                                selectedQuotation.id_mic_detail_sample,
                                                                selectedQuotation.id_mic_sample,
                                                                selectedQuotation.name_mic_sampling,
                                                                selectedQuotation.name_mic_sample,
                                                                selectedQuotation.id_mic_site,
                                                                true
                                                            );
                                                        }}
                                                    >
                                                        <i className="pi pi-sync"></i>
                                                        Cambiar
                                                    </button>

                                                </div>

                                            </div>
                                        </OverlayPanel>

                                        <OverlayPanel
                                            ref={ops}
                                            className="ios-sample-popover"
                                            appendTo={document.body}
                                        >
                                            <div className="ios-sample-popover-content">

                                                <div className="ios-sample-popover-top">

                                                    <span>
                                                        Lugar de toma
                                                    </span>

                                                    <strong>
                                                        {selectedSiteQuotation?.name_mic_site}
                                                    </strong>

                                                </div>


                                                <div className="ios-sample-popover-actions">

                                                    <button
                                                        type="button"
                                                        onClick={() => {

                                                            if (ops.current) {
                                                                ops.current.hide();
                                                            }

                                                            handleEditSite(
                                                                selectedSiteQuotation.id_mic_detail_sample,
                                                                selectedSiteQuotation.id_mic_sample,
                                                                selectedSiteQuotation.name_mic_site,
                                                                selectedSiteQuotation.name_mic_sample,
                                                                selectedSiteQuotation.id_mic_site,
                                                                false
                                                            );
                                                        }}
                                                    >
                                                        <i className="pi pi-pencil"></i>
                                                        Renombrar
                                                    </button>


                                                    <button
                                                        type="button"
                                                        onClick={() => {

                                                            if (ops.current) {
                                                                ops.current.hide();
                                                            }

                                                            handleEditSite(
                                                                selectedSiteQuotation.id_mic_detail_sample,
                                                                selectedSiteQuotation.id_mic_sample,
                                                                selectedSiteQuotation.name_mic_site,
                                                                selectedSiteQuotation.name_mic_sample,
                                                                selectedSiteQuotation.id_mic_site,
                                                                true
                                                            );
                                                        }}
                                                    >
                                                        <i className="pi pi-sync"></i>
                                                        Cambiar
                                                    </button>

                                                </div>

                                            </div>
                                        </OverlayPanel>

                                        <OverlayPanel
                                            ref={opss}
                                            className="ios-sample-popover"
                                            appendTo={document.body}
                                        >
                                            <div className="ios-sample-popover-content">

                                                <div className="ios-sample-popover-top">

                                                    <span>
                                                        Observaciones
                                                    </span>

                                                    <strong
                                                        style={{
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word"
                                                        }}
                                                    >
                                                        {selectedObservationQuotation?.observations ||
                                                            "Sin observaciones"}
                                                    </strong>

                                                </div>


                                                <div className="ios-sample-popover-actions">

                                                    <button
                                                        type="button"
                                                        onClick={() => {

                                                            if (opss.current) {
                                                                opss.current.hide();
                                                            }

                                                            editObservation(
                                                                selectedObservationQuotation.id_mic_detail_sample,
                                                                selectedObservationQuotation.id_mic_sample,
                                                                selectedObservationQuotation.name_mic_site,
                                                                selectedObservationQuotation.name_mic_sample,
                                                                selectedObservationQuotation.id_mic_site,
                                                                false,
                                                                selectedObservationQuotation.observations
                                                            );
                                                        }}
                                                    >
                                                        <i className="pi pi-pencil"></i>
                                                        Editar
                                                    </button>

                                                </div>

                                            </div>
                                        </OverlayPanel>

                                    </Card>

                                </Col>

                            </div >

                        </div >

                    </div >

                    {/* FOOTER */}
                    < div
                        className="footer-hamburger mobile-only"
                    >
                        <i className="fa fa-usd"></i>
                    </div >

                    <div className={`footer-wrapper open`}>
                        <footer className="pos-footer">

                            <div className="footer-stats">

                                <div className="footer-study-cancell" onClick={handleCancelWorkOrderUpdate}>
                                    <i className="fa fa-times-circle"></i>
                                    <span>Cancelar</span>
                                </div>


                                <div className="footer-stats">

                                    <div className="stat">
                                        <span>SUBTOTAL</span>
                                        <strong>$ {number_format(subTotalW, 2)}</strong>
                                    </div>


                                    <div className="stat">
                                        <span>IVA ( {informationSampling[0]?.tax_border ? "8%" : "16%"})</span>
                                        <strong>$ {number_format(totalTaxesW, 2)}</strong>
                                    </div>

                                    <div className="footer-total-quoter-mic-admision">
                                        <span className="total-quoter-label">TOTAL </span>
                                        <strong>$ {number_format(totalW, 2)}</strong>
                                    </div>

                                </div>

                            </div>





                            {
                                // * CONFIGURATION  TOTAL ORDER
                            }
                            <div className={`footer-right ${!informationPatient?.name ? "blocked" : ""}`}>
                                {id_company?.value && (
                                    <div className="footer-chip success">
                                        <i className="fa fa-credit-card"></i>
                                        <span>
                                            Pago:
                                            {
                                                isPayForCompany && <b className=''>La empresa</b>
                                            }
                                            {
                                                !isPayForCompany && <b className=''>El paciente</b>
                                            }

                                        </span>
                                    </div>
                                )}



                                <div className="footer-chip info">
                                    <span className="chip-icon">
                                        <i className="pi pi-file-pdf "></i>
                                    </span>
                                    <span>
                                        {isPayForCompany && "Factura: Empresa"}
                                        {!isPayForCompany && "Factura: Paciente (opcional)"}
                                        {!checkInvoice && "Factura: No solicito"}

                                    </span>
                                </div>

                            </div>



                            {/* RIGHT */}
                            <div className={`footer-right ${!informationPatient?.name ? "blocked" : ""}`}>
                                <div className="footer-study-count">
                                    <span className="badge-count">{listTest.length}</span>
                                    <span>{listTest.length === 1 ? "Determinación" : "Determinaciones"}</span>
                                </div>

                                {
                                    sampleSelected?.id_mic_detail_sample > 0 &&
                                    <Button
                                        className="btn-pay"
                                        onClick={togglePreviewD}
                                        disabled={loadingAddDeterminations}
                                    >
                                        {
                                            loadingAddDeterminations ? "Actualizando" : "Cobrar ahora"
                                        } <i className="pi pi-chevron-right"></i>
                                    </Button>

                                }






                            </div>

                        </footer>
                    </div>

                </div >
            }








            {
                // * CONFIGURATION ACTIONS DIALOGS
            }
            <Dialog
                header={dataInfo.title}
                visible={modalSample}
                onHide={toggleModalSample}
                headerStyle={{
                    backgroundColor: '#cb0b1d',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: '#cb0b1d', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
                className="pt-0 custom-dialog-img-sample"
                footer={
                    <div>
                        <Button disabled={loadingIsDevolution ? true : false} onClick={() => dataInfo.isSample ? deleteSamplingOrder() : deleteSamplingOrder()} color='secondary' type="button"> <i className={loadingIsDevolution ? "pi pi-spin pi-spinner" : null} style={{ fontSize: "0.8rem" }} /> {loadingIsDevolution ? "Guardando" : "Guardar"}</Button>
                    </div>
                }
            >
                <Col sm="12" className='pt-2 p-l-0 p-r-0' >
                    <label style={{ color: "#565a5efc", fontWeight: "bold", fontSize: "15px" }}  >{dataInfo.message}</label> <br />
                    <label>{dataInfo.message_bold}</label   >
                    <br /> <br />
                    <Col className='shadow-sm' sm="12"
                        style={{
                            backgroundColor: 'white',
                            border: '1px solid #e0e0e0',
                            borderRadius: '10px',
                            padding: '12px',
                            fontSize: '12px'
                        }}>
                        <label className='txt-danger f-w-700'>Selecciona un motivo por el que se cancelara</label>
                        <Select
                            classNamePrefix="select"
                            name="id_mic_return_reason"
                            value={dataInfo?.id_mic_return_reason}
                            placeholder="Selecciona un motivo"
                            options={listReturnReason}
                            onChange={(e) => handleChangeReturnReason(e,)}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                        />
                        <br /><br /><br />
                    </Col>
                </Col>
            </Dialog>
            {
                // ? UPDATE SAMPLE
            }
            <Dialog
                dismissableMask={false}
                header={
                    <div className="seller-dialog-header">
                        <div className="seller-dialog-header__content">

                            <div className="seller-dialog-icon">
                                <i className="icofont icofont-tablets f-20"></i>
                            </div>

                            <div>
                                <div className="seller-dialog-title">
                                    {formMic.name_mic_sample}
                                </div>
                            </div>

                        </div>
                    </div>
                }
                className={`seller-dialog seller-dialog seller-danger  seller-medium `}
                blockScroll={true}
                visible={modalUpdateSample}
                onHide={toggleModalUpdateSample}
                maskClassName="custom-total-mask"
                footer={
                    <div>
                        {
                            formMic.is_change ?
                                <Button disabled={loadingUpdate ? true : false} onClick={() => saveUpdateChangeSampling()} color='secondary' type="button"> Guardar </Button>

                                :
                                <Button disabled={loadingUpdate ? true : false} onClick={() => saveUpdateSampling()} color='secondary' type="button"> Guardar </Button>

                        }
                    </div>
                }
            >
                <Col sm="12" className={formMic.is_change ? "d-none" : 'pt-3 p-l-0 p-r-0'}  >

                    <div
                        style={{
                            background: "#fff4e5",
                            border: "1px solid #ffcc80",
                            borderLeft: "6px solid #ff9800",
                            borderRadius: "12px",
                            padding: "13px",
                            marginBottom: "10px",
                            display: "flex",
                            alignItems: "center",
                            gap: "15px"
                        }}
                    >
                        <i
                            className="pi pi-exclamation-triangle"
                            style={{
                                fontSize: "2rem",
                                color: "#ff9800"
                            }}
                        />
                        <div>
                            <div
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "700",
                                    color: "#e65100",
                                    marginBottom: "4px"
                                }}
                            >
                                Advertencia
                            </div>

                            <div
                                style={{
                                    fontSize: "13px",
                                    color: "#6b7280"
                                }}
                            >
                                Al modificar la descripción de las muestra, el cambio se aplicará de forma global y se reflejará en&nbsp;
                                <strong> todos los registros existentes e históricos</strong>.
                                donde esta muestra haya sido utilizado dentro de la base de datos.
                                <strong>
                                    Se recomienda utilizar esta opción únicamente para corregir errores ortográficos,
                                    de escritura o realizar ajustes menores en descripción de las muestra.
                                </strong>

                                Si el cambio representa un descripción de las muestra diferente o modifica su finalidad,
                                utilice la opción  <strong> Cambiar</strong> para preservar la integridad de la información histórica.
                            </div>
                        </div>
                    </div>
                    <br />
                    <label style={{ fontSize: "14px" }} >Se modificara el tipo de muestra:&nbsp; <b className='txt-danger' >{formMic.name_mic_sampling} </b> </label>
                    <Col sm="12" className='p-l-0 p-r-0 pt-3 pb-3' >
                        <input
                            value={formMic.name_newSampling}
                            name="name_newSampling"
                            onChange={handleChangeSample}
                            className="mr-2 input-line2"
                            style={{ fontSize: "14px" }}
                        />
                    </Col>


                </Col>
                <Col wsm="12" className={!formMic.is_change ? "d-none" : 'pt-2 p-l-0 p-r-0'} >
                    <div
                        style={{
                            background: "#fff4e5",
                            border: "1px solid #ffcc80",
                            borderLeft: "6px solid #ff9800",
                            borderRadius: "12px",
                            padding: "13px",
                            marginBottom: "10px",
                            display: "flex",
                            alignItems: "center",
                            gap: "15px"
                        }}
                    >
                        <i
                            className="pi pi-exclamation-triangle"
                            style={{
                                fontSize: "2rem",
                                color: "#ff9800"
                            }}
                        />
                        <div>
                            <div
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "700",
                                    color: "#e65100",
                                    marginBottom: "4px"
                                }}
                            >
                                Advertencia
                            </div>

                            <div
                                style={{
                                    fontSize: "13px",
                                    color: "#6b7280"
                                }}
                            >

                                <strong> Esta opción permite corregir la descripción de la muestra asociado únicamente a este NIM</strong>.
                                Utilícela cuando el la descripción de la muestra haya sido seleccionado por error durante la captura
                                <strong>(por ejemplo, se registró un Sándwich cuando en realidad correspondía un Bagel)</strong>.
                                Esta modificación no afecta el catálogo de  descripción de la muestra ni otros registros.
                            </div>
                        </div>
                    </div>


                    <label style={{ fontSize: "14px" }} >Se cambiara la descripción de muestra:&nbsp; <b>{formMic.name_mic_sampling} </b> </label>
                    <Col sm="12" className='p-l-0 p-r-0 pt-3 pb-3'  >
                        <Select
                            classNamePrefix="select"
                            name="id_mic_sample_change"
                            value={formMic?.id_mic_sample_change}
                            placeholder="Selecciona un sitio"
                            options={listSample}
                            onChange={(e) => handleSample(e)}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                        />
                    </Col>
                    <div
                        className={formMic.id_mic_sample_change === null ? "d-none" : ""}
                        style={{
                            color: "#856404",
                            fontSize: "10px",
                            marginTop: "6px",
                            fontWeight: "500",
                            backgroundColor: "#fff3cd",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            border: "1px solid #ffeeba",
                        }}
                    >
                        <i
                            className="fa fa-exclamation-triangle"
                            style={{ color: "#d39e00" }}
                        ></i>

                        <p style={{ fontSize: "10px", margin: 0 }}>
                            Se cambiará la descripción{" "}
                            <strong>{formMic.name_mic_sampling || "---"}</strong>
                            {" por "}
                            <strong>{formMic.id_mic_sample_change?.label || ""}</strong>.
                        </p>
                    </div>

                </Col>
            </Dialog >
            {
                // ? UPDATE SITE

            }
            <Dialog
                //  header={formMic.name_mic_sample}
                visible={modalUpdateSite}
                onHide={toggleModalUpdateSite}
                header={
                    <div className="seller-dialog-header">
                        <div className="seller-dialog-header__content">

                            <div className="seller-dialog-icon">
                                <i className="icofont icofont-tablets f-20"></i>
                            </div>

                            <div>
                                <div className="seller-dialog-title">
                                    {formMic.name_mic_sample}
                                </div>
                            </div>

                        </div>
                    </div>
                }
                className={`seller-dialog seller-dialog seller-danger  seller-medium `}
                maskClassName="custom-total-mask"


                footer={
                    <div>
                        {
                            formMic.is_change ?
                                <Button disabled={loadingUpdate ? true : false} onClick={() => saveUpdateChangeSite()} color='secondary' type="button"> Guardar </Button>

                                :
                                <Button disabled={loadingUpdate ? true : false} onClick={() => saveUpdateSite()} color='secondary' type="button"> Guardar </Button>

                        }
                    </div>
                }
            >
                <Col sm="12" className={formMic.is_change ? "d-none" : 'pt-2 p-l-0 p-r-0'}  >
                    <div
                        style={{
                            background: "#fff4e5",
                            border: "1px solid #ffcc80",
                            borderLeft: "6px solid #ff9800",
                            borderRadius: "12px",
                            padding: "13px",
                            marginBottom: "10px",
                            display: "flex",
                            alignItems: "center",
                            gap: "15px"
                        }}
                    >
                        <i
                            className="pi pi-exclamation-triangle"
                            style={{
                                fontSize: "2rem",
                                color: "#ff9800"
                            }}
                        />
                        <div>
                            <div
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "700",
                                    color: "#e65100",
                                    marginBottom: "4px"
                                }}
                            >
                                Advertencia
                            </div>

                            <div
                                style={{
                                    fontSize: "13px",
                                    color: "#6b7280"
                                }}
                            >
                                Al modificar el lugar de la toma, el cambio se aplicará de forma global y se reflejará en&nbsp;
                                <strong> todos los registros existentes e históricos</strong>.
                                donde este lugar de toma haya sido utilizado dentro de la base de datos.
                                <strong>
                                    Se recomienda utilizar esta opción únicamente para corregir errores ortográficos,
                                    de escritura o realizar ajustes menores en el lugar de la toma.
                                </strong>

                                Si el cambio representa un cambio de lugar diferente a la toma,
                                utilice la opción  <strong> Cambiar</strong> para preservar la integridad de la información histórica.
                            </div>
                        </div>
                    </div>
                    <label style={{ fontSize: "14px" }} >Se modificara el lugar de la toma:&nbsp; <b className='txt-danger' >{formMic.name_mic_site} </b> </label>
                    <Col sm="12" className='p-l-0 p-r-0 pt-3 pb-3' >
                        <input
                            value={formMic.name_newSite}
                            name="name_newSite"
                            onChange={handleChangeSite}
                            className="mr-2 input-line2"
                            style={{ fontSize: "14px" }}
                        />
                    </Col>


                </Col>
                <Col wsm="12" className={!formMic.is_change ? "d-none" : 'pt-2 p-l-0 p-r-0'} >
                    <div
                        style={{
                            background: "#fff4e5",
                            border: "1px solid #ffcc80",
                            borderLeft: "6px solid #ff9800",
                            borderRadius: "12px",
                            padding: "13px",
                            marginBottom: "10px",
                            display: "flex",
                            alignItems: "center",
                            gap: "15px"
                        }}
                    >
                        <i
                            className="pi pi-exclamation-triangle"
                            style={{
                                fontSize: "2rem",
                                color: "#ff9800"
                            }}
                        />
                        <div>
                            <div
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "700",
                                    color: "#e65100",
                                    marginBottom: "4px"
                                }}
                            >
                                Advertencia
                            </div>

                            <div
                                style={{
                                    fontSize: "13px",
                                    color: "#6b7280"
                                }}
                            >

                                <strong> Esta opción permite corregir el cambio del lugar de la muestra asociado únicamente a este NIM</strong>.
                                Utilícela cuando el lugar de la muestra haya sido seleccionado por error durante la captura
                                <strong>(por ejemplo, se registró el el Comedor cuando en realidad era de la cocina)</strong>.
                                Esta modificación no afecta el catálogo del lugar de las muestras ,  ni otros registros.
                            </div>
                        </div>
                    </div>
                    <label style={{ fontSize: "14px" }} >Se cambiara el lugar de la muestra:&nbsp; <b>{formMic.name_mic_site} </b> </label>
                    <Col sm="12" className='p-l-0 p-r-0 pt-3 pb-3'  >
                        <Select
                            classNamePrefix="select"
                            name="id_mic_site_change"
                            value={formMic?.id_mic_site_change}
                            placeholder="Selecciona un sitio"
                            options={listSite}
                            onChange={(e) => handleSite(e)}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                        />
                    </Col>


                </Col>
            </Dialog >
            {
                // ? UPDATE OBSERVATION
            }
            <Dialog
                visible={modalUpdateObservation}
                onHide={toggleModalUpdateObservation}
                draggable={false}
                modal={false}
                maskClassName="custom-cancell-mask"
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">

                            <div className="Global-dialog-icon">
                                <i className="pi pi-history"></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    Historico de la orden
                                </div>
                            </div>

                        </div>
                    </div>
                }
                className={`Global-dialog Global-dialog Global-blue Global-small-v `}
                footer={
                    <div>
                        <Button disabled={loadingUpdate ? true : false} onClick={() => saveUpdateObservation()} color='secondary' type="button"> Guardar </Button>
                        <Button disabled={loadingUpdate ? true : false} onClick={toggleModalUpdateObservation} color='danger' type="button"> Cancelar </Button>
                    </div>
                }
            >
                <Col sm="12" className="pt-2 p-l-0 p-r-0">

                    <label style={{ fontSize: "14px" }}>
                        Se modificará la observación:&nbsp;
                        <b>{formMic.observationsM}</b>
                    </label>

                    <Col sm="12" className="p-l-0 p-r-0 pt-3 pb-3">

                        <textarea
                            value={formMic.observationsN ?? ""}
                            name="observationsN"
                            onChange={handleChangeObservation}
                            className="input-admision"
                            placeholder="Escribe la nueva observación..."
                            rows={2}
                            style={{
                                fontSize: "14px",
                                width: "100%",
                                minHeight: "100px",
                                resize: "vertical",
                                padding: "10px 12px",
                                lineHeight: "1.5"
                            }}
                        />
                    </Col>
                    <div
                        className={formMic.observationsN === null ? "d-none" : ""}
                        style={{
                            color: "#856404",
                            fontSize: "12px",
                            marginTop: "6px",
                            fontWeight: "500",
                            backgroundColor: "#fff3cd",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            border: "1px solid #ffeeba",
                        }}
                    >
                        <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                        {`Este sera la nueva observación:  ${formMic.observationsN}`}
                    </div>
                </Col>
            </Dialog >


            {
                // ? ADD DETERMINATIONS
            }


            <Dialog
                // header={dataDetermination.title}
                visible={modalAddDeterminations}
                onHide={toggleModalDeterminations}
                header={
                    <div className="seller-dialog-header">
                        <div className="seller-dialog-header__content">

                            <div className="seller-dialog-icon">
                                <i className="fa fa-plus"></i>
                            </div>

                            <div>
                                <div className="seller-dialog-title">
                                    {dataDetermination.title}
                                </div>
                            </div>

                        </div>
                    </div>
                }
                className={errors.length > 0 ? `eller-dialog seller-dialog seller-danger   seller-medium ` : `Global-dialog Global-blue   seller-medium `}
                maskClassName="custom-total-mask"

            >

                <Col sm="12" className="pl-0 pr-0">

                    {errors.length > 0 ? (
                        <div
                            style={{
                                background: "#fff5f5",
                                border: "1px solid #f5c2c7",
                                borderRadius: "12px",
                                padding: "16px",
                                marginTop: "10px",
                                boxShadow: "0 2px 8px rgba(220,53,69,0.08)"
                            }}
                        >

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    marginBottom: "12px",
                                    paddingBottom: "10px",
                                    borderBottom: "1px solid #f5c2c7"
                                }}
                            >
                                <i
                                    className="fa fa-exclamation-triangle"
                                    style={{
                                        color: "#dc3545",
                                        fontSize: "1.3rem"
                                    }}
                                />

                                <div>
                                    <div
                                        style={{
                                            fontWeight: "600",
                                            color: "#842029",
                                            fontSize: "1rem"
                                        }}
                                    >
                                        No se pueden agregar determinaciónes
                                    </div>

                                    <small
                                        style={{
                                            color: "#6c757d"
                                        }}
                                    >
                                        Corrige los siguientes problemas para continuar.
                                    </small>
                                </div>
                            </div>

                            <Col sm="12" style={{ textAlign: "center" }}>
                                <img
                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                    style={{
                                        width: "35%",
                                        marginBottom: "15px"
                                    }}
                                    alt="Sin Muestras"
                                />
                            </Col>

                            <div
                                style={{
                                    background: "#fff",
                                    borderRadius: "12px",
                                    border: "1px solid #f1d5d8",
                                    overflow: "hidden"
                                }}
                            >

                                <div
                                    style={{
                                        padding: "10px 15px",
                                        background: "#fff8f8",
                                        borderBottom: "1px solid #f1d5d8",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        fontWeight: "600",
                                        color: "#842029"
                                    }}
                                >
                                    <i className="pi pi-shield"></i>
                                    Validaciones encontradas ({errors.length})
                                </div>

                                {errors.map((error, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "12px",
                                            padding: "12px 15px",
                                            borderBottom:
                                                index !== errors.length - 1
                                                    ? "1px solid #f5f5f5"
                                                    : "none"
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: "24px",
                                                height: "24px",
                                                minWidth: "24px",
                                                borderRadius: "50%",
                                                background: "#fff1f2",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                        >
                                            <i
                                                className="pi pi-times"
                                                style={{
                                                    color: "#dc3545",
                                                    fontSize: ".75rem"
                                                }}
                                            />
                                        </div>

                                        <span
                                            style={{
                                                color: "#495057",
                                                fontSize: ".92rem",
                                                lineHeight: "1.4"
                                            }}
                                        >
                                            {error}
                                        </span>
                                    </div>
                                ))}

                            </div>

                        </div>

                    ) : (

                        <div
                            style={{
                                background: "#f8fafc",
                                border: "1px solid #e2e8f0",
                                borderRadius: "12px",
                                padding: "18px",
                                marginTop: "10px"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    marginBottom: "15px"
                                }}
                            >
                                <div
                                    style={{
                                        width: "42px",
                                        height: "42px",
                                        borderRadius: "50%",
                                        background: "#e7f1ff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    <i
                                        className="pi pi-search"
                                        style={{
                                            color: "#0d6efd",
                                            fontSize: "1.1rem"
                                        }}
                                    />
                                </div>

                                <div>
                                    <div
                                        style={{
                                            fontWeight: "600",
                                            color: "#0d3b59",
                                            fontSize: "1rem"
                                        }}
                                    >
                                        Buscar determinación
                                    </div>

                                </div>
                            </div>

                            <FormGroup className="mb-0">
                                <SearchAsync
                                    loincState={searchExamProfileState}
                                    name="id_profileExam"
                                    method={handleSelectExamChange}
                                    url={
                                        validRestrictCompany === "True" && checkTypeClient === 3
                                            ? `Profiles/SearchProfileExamCompany?id_agreement=${_valid_url}`
                                            : `Profiles/SearchProfileExam`
                                    }
                                    maxLenght={3}
                                    isWorkOrder={true}
                                    ismenuPlacement="top"
                                    is_micro={true}
                                />
                            </FormGroup>
                        </div>
                    )}

                </Col>

            </Dialog >

            {
                // ? PREVIEW
            }
            {/* <Dialog
                visible={previewDetermination}
                onHide={togglePreviewD}
                header={
                    <div className="seller-dialog-header">
                        <div className="seller-dialog-header__content">

                            <div className="seller-dialog-icon">
                                <i className="fa fa-refresh"></i>
                            </div>

                            <div>
                                <div className="seller-dialog-title">
                                    Actualizar determinaciones
                                </div>
                            </div>

                        </div>
                    </div>
                }
                className={`Global-dialog Global-blue   seller-medium `}
                maskClassName="custom-total-mask"
                footer={

                    <Button disabled={loadingAddDeterminations ? true : false} onClick={() => saveDeterminations()} color='secondary' type="button"> {loadingAddDeterminations ? "Cargando..." : "Aceptar"}  </Button>
                }
            >
                <Col sm="12" className='pl-0 pr-0 ' >
                    <div
                        style={{
                            color: "#856404",
                            fontSize: "12px",
                            marginTop: "6px",
                            fontWeight: "500",
                            backgroundColor: "#fff3cd",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            border: "1px solid #ffeeba",
                        }}
                    >
                        <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                        {"Se agregaran las siguientes determinaciones , en sus folios correspondientes." ?? "---"}
                    </div> <br />
                    {groupedData.map((item, index) => {

                        const newTests = item.tests.filter(x => x.isNew);

                        if (newTests.length === 0) return null;

                        return (
                            <Card key={index} className="shadow mb-3">
                                <CardBody className='pl-1 pr-1 pt-2 pb-2 '  >

                                    <Row>
                                        <Col md="4" className='pt-4' >
                                            <div className="d-flex align-items-center">
                                                <div
                                                    style={{
                                                        width: "15px",
                                                        height: "15px",
                                                        borderRadius: "50%",
                                                        background: "#4f83d1",
                                                        marginRight: "10px"
                                                    }}
                                                />

                                                <strong style={{ fontSize: "12px" }} >
                                                    Folio - {item.folio}
                                                </strong>
                                            </div>
                                        </Col>

                                        <Col md="4" className="text-center">
                                            <label style={{ fontSize: "12px", fontWeight: "bold" }} >Tipo de muestra</label>
                                            <br />
                                            <Tag style={{ fontSize: "10px" }} value={item.name_mic_sample} severity="info" />
                                        </Col>

                                        <Col md="4" className="text-center">
                                            <label style={{ fontSize: "12px", fontWeight: "bold" }} >Estatus</label>
                                            <br />
                                            <Tag style={{ fontSize: "10px" }} value="NUEVO" severity="warning" />
                                        </Col>
                                    </Row>

                                    <hr />

                                    <label
                                        style={{
                                            color: "#6c757d",
                                            fontWeight: "600",
                                            fontSize: "13px"
                                        }}

                                    >
                                        Determinaciones
                                    </label>

                                    {newTests.map((test, i) => (
                                        <div
                                            key={i}
                                            style={{
                                                fontWeight: "600",
                                                color: "#0b5e8e",
                                                marginTop: "5px",
                                                fontSize: "12px"
                                            }}

                                        >
                                            • {test.test_name}
                                        </div>
                                    ))}

                                </CardBody>
                            </Card>
                        );
                    })}

                </Col>


            </Dialog > */}

            <Dialog visible={previewDetermination} onHide={togglePreviewD}
                header={
                    <div className="dialog-header-fix">
                        <div className="header-left-fix">
                            <span className="header-title-fix">
                                Cierre de venta
                            </span>
                        </div>

                        <div className="header-right-fix">
                            <div className="header-badge-fix">
                                <div className="header-icon-fix">
                                    <i className="fa fa-flask"></i>
                                </div>

                                <span>
                                    {listTest.length}{" "}
                                    {listTest.length === 1 ? "Determinación" : "Determinaciones"}
                                </span>
                            </div>
                        </div>
                    </div>
                }
                modal
                maskClassName="custom-total-mask"
                draggable={false}
                className={`custom-total-modal`}
            >
                <Col sm="12" className="pl-0 pr-0">
                    <>
                        {groupedData.map((item, index) => {
                            const newTests = item.tests.filter(x => x.isNew);

                            if (newTests.length === 0) return null;

                            return (
                                <div key={index} className="determination-sale-layout">

                                    {/* BLOQUE SUPERIOR */}
                                    <div className="determination-sale-hero">

                                        <div className="determination-sale-hero-left">

                                            <span className="determination-sale-small">
                                                Tipo de muestra
                                            </span>

                                            <strong className="determination-sale-folio">
                                                {item.name_mic_sample || "Sin especificar"}
                                            </strong>

                                        </div>

                                        <div className="determination-sale-hero-right">

                                            <div className="determination-sale-sample-icon">
                                                <i className="fa fa-file-text-o"></i>
                                            </div>

                                            <div>
                                                <span className="determination-sale-small">
                                                    Folio
                                                </span>

                                                <strong>
                                                    {item.folio}
                                                </strong>
                                            </div>

                                        </div>

                                    </div>

                                    <div className="determination-sale-section-title">
                                        <div>
                                            <i className="fa fa-vials"></i>
                                            <span>Determinaciones</span>
                                        </div>

                                        <div className="determination-sale-count">
                                            {newTests.length > 0 ? `+${newTests.length}` : "0"}
                                        </div>
                                    </div>


                                    {/* LISTA */}
                                    <div className="determination-sale-list">

                                        {newTests.map((test, i) => (
                                            <div
                                                key={i}
                                                className="determination-sale-row"
                                            >

                                                <div className="determination-sale-row-icon">
                                                    <i className="fa fa-flask"></i>
                                                </div>

                                                <div className="determination-sale-row-content">

                                                    <span className="determination-sale-row-label">
                                                        Determinación
                                                    </span>

                                                    <strong>
                                                        {test.test_name}
                                                    </strong>

                                                </div>

                                                <span className="determination-sale-new">
                                                    Nuevo
                                                </span>

                                            </div>
                                        ))}

                                    </div>

                                </div>
                            );
                        })}

                        <button
                            className={`btn-main-action ${loadingAddDeterminations ? "Cargando..." : ""}`}
                            disabled={loadingAddDeterminations ? true : false}
                            onClick={() => saveDeterminations()}
                        >
                            <span>{"Aceptar"}</span>
                        </button>
                    </>

                </Col>

            </Dialog>
        </>
    );
};